export type Row = {
  before: string
  after: string
}

/** Section 11 — Transformation. */
export const transformationRows: Row[] = [
  {
    before: 'Every broken week means starting the whole system over',
    after: 'A twenty-minute reset, and the system keeps running',
  },
  {
    before: 'The plan lives in your head, and only you can run a day',
    after: 'The whole homeschool lives on one page anyone can read',
  },
  {
    before: 'Every paper kept, just in case, in a box you avoid',
    after: 'A handful of chosen samples, filed the same month',
  },
  {
    before: 'Sunday night spent bracing for Monday',
    after: 'Sunday: week closed, week set, in twenty minutes',
  },
  {
    before: 'Kids waiting to be told what happens next',
    after: 'Kids running their own routine cards without being asked',
  },
  {
    before: '“I’m the unorganized one”',
    after:
      'The person running the whole operation — with a system that finally shows it',
  },
]

/** Section 15 — Cost of inaction. */
export const costRows: Row[] = [
  {
    before: 'Buying another planner each time one dies',
    after: 'The same purchase, on repeat, year after year',
  },
  {
    before: 'Rebuilding the year’s plan from scratch after each collapse',
    after: 'Weekends you don’t get back',
  },
  {
    before: 'Keeping every paper because you’re not sure what counts',
    after: 'A box you’re afraid to open — and still nothing you’d want to show',
  },
  {
    before: 'The whole schedule living only in your head',
    after:
      'Nobody else can run a single day without you, including the days you’re sick',
  },
  {
    before: 'Calling yourself the unorganized one',
    after: 'The story stays true, because nothing about the design ever changed',
  },
]

/** Section 16 — Close. */
export const closeRows: Row[] = [
  {
    before: 'Rebuild the plan every time a week breaks',
    after: 'Twenty minutes, and the plan is still standing',
  },
  {
    before: 'Keep everything, in case it counts',
    after: 'Log what matters, file what’s worth keeping',
  },
  {
    before: 'Start over in January, and again in September',
    after: 'Reset on Sunday, and just keep going',
  },
]
